import { render, staticRenderFns } from "./change-movie-form.vue?vue&type=template&id=5c8c73a0&"
import script from "./change-movie-form.vue?vue&type=script&lang=ts&"
export * from "./change-movie-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports